import React, { Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Navbar from "react-bootstrap/Navbar";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";

class DriverProfile extends React.Component {
  constructor(props) {
    super(props);
    // console.log(props);
  }

  componentDidMount() {
    this.props.driver;
  }

  render() {
    const { driver } = this.props;
    return (
      <div className="container-fluid">
        <Navbar className="bg-info justify-content-between">
          <Navbar.Brand>
            {driver.first_name} {driver.last_name}
          </Navbar.Brand>
          <Link to="/stats">
            <Button variant="outline-light">Back to Stakeholders</Button>
          </Link>
        </Navbar>
        <Form>
          <br></br>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridFirstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                readOnly
                name="first_name"
                value={driver.first_name}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridLastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                name="last_name"
                readOnly
                value={driver.last_name}
              />
            </Form.Group>
            <Col sm="2">
              <Form.Group>
                <Form.Label>Active</Form.Label>
                <Form.Check name="active" checked={driver.active} readOnly />
              </Form.Group>
            </Col>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridMobile">
              <Form.Label>Mobile Phone</Form.Label>
              <Form.Control
                readOnly
                value={
                  driver.mobile_contact_number
                    ? driver.mobile_contact_number
                    : ""
                }
                name="mobile_contact_number"
              />
            </Form.Group>
            <Col sm="2">
              <Form.Group>
                <Form.Label>Apple iPhone?</Form.Label>
                <Form.Check name="iPhone" checked={driver.iPhone} readOnly />
              </Form.Group>
            </Col>
            {/* <Form.Group as={Col} controlId="formGridType">
              <Form.Label>Mobile Phone Type</Form.Label>
              <Form.Control
                readOnly
                value={driver.mobile_phone_type ? driver.mobile_phone_type : ""}
                name="mobile_phone_type"
              />
            </Form.Group> */}
            <Form.Group as={Col} controlId="formGridEmail">
              <Form.Label>iCloud Email</Form.Label>
              <Form.Control
                name="icloud_email"
                readOnly
                value={driver.icloud_email ? driver.icloud_email : ""}
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridTwilio">
              <Form.Label>Twilio Phone</Form.Label>
              <Form.Control
                name="twilio_phone_number"
                readOnly
                value={
                  driver.twilio_phone_number ? driver.twilio_phone_number : ""
                }
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridCustomerPhone">
              <Form.Label>Active Conversation Phone</Form.Label>
              <Form.Control
                readOnly
                value={
                  driver.active_conversation_phone_number
                    ? driver.active_conversation_phone_number
                    : ""
                }
                name="active_conversation_phone_number"
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridDelivery">
              <Form.Label>Active Delivery Id</Form.Label>
              <Form.Control
                readOnly
                value={
                  driver.active_delivery_id ? driver.active_delivery_id : ""
                }
                name="active_delivery_id"
              />
            </Form.Group>
          </Form.Row>
        </Form>
      </div>
    );
  }
}

export default withRouter(DriverProfile);
